import refs from '../helpers/refs'

class CSearch {
  constructor (el) {
    this.search = el
    this.$refs = refs(this.search)
    this.showType = this.search.dataset.showType

    this.init()
  }

  init () {
    // Form submit
    for (const submit of document.body.querySelectorAll('[ref="searchForm"]')) {
      submit.addEventListener('submit', (e) => {
        e.preventDefault()
        this.submit()
      })
    }

    // Result type buttons
    /*
    this.$refs.searchRecipes.addEventListener('click', () => {
      this.showType = 'article'
      this.submit()
    })
    this.$refs.searchProducts.addEventListener('click', () => {
      this.showType = 'product'
      this.submit()
    })
    */
  }

  submit (showType = this.showType) {
    const query = this.$refs.searchInput.value
    const url = `/search?q=${query}&showType=${showType}`

    window.location.href = url
  }
}

window.addEventListener('load', () => {
  document.querySelectorAll('.c-search').forEach(el => new CSearch(el))
})
